import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Button } from './ui/Button'
import {
  StyledHeader,
  HeaderContent,
  BrandSection,
  AppTitle,
  AppSubtitle,
  UserSection,
  UserInfo,
  UserName,
  UserRole as StyledUserRole,
} from './Header.styles'

const Header: React.FC = () => {
  const { user, signOut } = useAuth()

  const handleLogout = async () => {
    try {
      await signOut()
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  return (
    <StyledHeader>
      <HeaderContent>
        <BrandSection>
          <AppTitle>Psychic Lamp</AppTitle>
          <AppSubtitle>Industrial ERP System</AppSubtitle>
        </BrandSection>
        <UserSection>
          <UserInfo>
            <UserName>Welcome, {user?.username || 'User'}</UserName>
            <StyledUserRole>
              Role: {user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase() : 'Unknown'}
            </StyledUserRole>
          </UserInfo>
          <Button variant="danger" size="sm" onClick={handleLogout}>
            Logout
          </Button>
        </UserSection>
      </HeaderContent>
    </StyledHeader>
  )
}

export default Header